export default __webpack_public_path__ + "static/media/ic_singapore.72f31b76.svg";